import axiosInstance from "../axiosInstance";

export const countriesArrayApi = () => {
  return axiosInstance.get(`/api/regions`);
};

export const regionsArrayApi = country_id => {
  return axiosInstance.get(`api/regions/${country_id}`);
};

export const resortsArrayApi = (region_id, page = 1) => {
  return axiosInstance.get(`/api/regions/${region_id}/resorts?page=${page}`);
};

export const topResorts = () =>
    axiosInstance.get('/api/top-resorts')
